<template>
    <v-container fluid>
        <v-row no-gutters class="d-block">
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <v-row>
                            <v-col cols="6" sm="3">
                                <v-btn color="success" small outlined @click="nuevoLote">
                                    <v-icon>add</v-icon>
                                    Nuevo
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="3">
                                <v-btn color="info" small outlined @click="getLotes">
                                    <v-icon>refresh</v-icon>
                                    Refrescar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text>
                        <v-data-table
                            dense
                            class="elevation-3"
                            :headers="tableHeaders"
                            :items="lotes"
                            :loading="loading"
                            item-key="lote_id"
                            fixed-header
                            height="65vh"
                            :hide-default-footer="true"
                            disable-pagination
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.lote_id }}</td>
                                    <td>{{ item.nombre }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.procesados }}</td>
                                    <td class="text-center">{{ item.pendientes }}</td>
                                    <td class="text-center">{{ item.errores }}</td>
                                    <td class="text-center">{{ item.porcentaje_procesado }}%</td>
                                    <td class="text-center">{{ item.estado }}</td>
                                    <td class="text-center">{{ item.criterios }}</td>
                                    <td>{{ item.fecha_creacion }}</td>
                                    <td class="text-center">
                                        <div class="d-flex justify-center">
                                            <!--
                                            <v-btn color="info" small outlined
                                                :disabled="item.estado != 'espera' "
                                                @click="editarLote(item)" title="Editar" class="me-2">
                                                <v-icon>edit</v-icon>
                                            </v-btn>
                                            -->
                                            <v-btn color="success" small outlined 
                                                :disabled="item.file_path == null || item.estado == 'error'"
                                                @click="descargarPdf(item)" 
                                                title="Descargar">
                                                <v-icon>download</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </template>

                            <template v-slot:no-data>
                                <v-alert dense type="warning" outlined class="text-center mt-3">
                                    No existen registros.
                                </v-alert>
                            </template>
                        </v-data-table>

                        <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina" v-if="pagination.total"/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Pagination from "@/pages/Components/Pagination.vue";

export default {
    name: 'LotesImpresionLista',
    components: { Pagination },
    data() {
        return {
            lotes: [],
            pagination: {},
            pageActual: 1,
            rowsPage: 15,
            loading: false,
            tableHeaders: [
                { text: 'ID', value: 'lote_id' },
                { text: 'Nombre', value: 'nombre' },
                { text: 'Total', value: 'total', align: 'center' },
                { text: 'Procesados', value: 'procesados', align: 'center' },
                { text: 'Pendientes', value: 'pendientes', align: 'center' },
                { text: 'Errores', value: 'errores', align: 'center' },
                { text: 'Porcentaje', value: 'porcentaje_procesado', align: 'center' },
                { text: 'Estado', value: 'estado', align: 'center' },
                { text: 'Criterio', value: 'criterios', align: 'center' },
                { text: 'Fecha Creación', value: 'fecha_creacion' },
                { text: 'Acciones', align: 'center' }
            ],
        }
    },
    methods: {
        nuevoLote() {
            this.$router.push({ name: 'AdministracionImpresionNuevo' });
        },
        getLotes() {
            this.loading = true;
            let params = { page: this.pageActual, per_page: this.rowsPage };
            //window.axios.get('http://private.infop.hn/api/lotes_impresion', { params })
            window.axios.get('/lotes_impresion', { params })
                .then(response => {
                    if (response.data.success) {
                        this.lotes = response.data.data.lotes.data;
                        this.pagination = response.data.data.pagination;
                    } else {
                        this.$toast.error(response.data.message || "Error al obtener lotes.");
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => this.loading = false);
        },
        editarLote(lote) {
            let token = window.btoa(lote.lote_id);
            this.$router.push({ name: 'EditarLote', query: { token } });
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.getLotes();
        },
        descargarPdf(lote) {
            this.url_certificado = `${this.baseURL}/${lote.file_path}`;            
            window.open(this.url_certificado, '_blank');
        },

    },
    created() {
        this.getLotes();
    },
    mounted() {
        // refresh every 15 seconds (15000 ms)
        this.refreshInterval = setInterval(() => {
            this.getLotes();
        }, 15000);
    },
    beforeUnmount() {
        // cleanup interval when component is destroyed
        if (this.refreshInterval) clearInterval(this.refreshInterval);
    }    
}
</script>
